<template>
  <div class="c-button button--rounded">
    <div class="button__cont">
      <router-link
        v-if="data.routerLink"
        class="button__link"
        :to="data.url"
      >
        <span v-html="data.content"></span>
      </router-link>
      <a
        v-else
        class="button__link"
        :href="data.url"
        target="_blank"
        rel="noopener"
      >
        <span v-html="data.content"></span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'baseButtonRounded',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-button.button--rounded {
  padding: 0;
  margin: 0;

  border: 1px solid $color-text;
  border-radius: 50%;

  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 700;

  &:focus {
    outline: transparent;
  }

  @at-root [data-theme="pink"] & {
    background-color: $color-pink;
  }

  @at-root [data-theme="blue"] & {
    background-color: $color-blue;
  }

  @at-root [data-theme="red"] & {
    background-color: $color-red;
  }

  @at-root [data-theme="azure"] & {
    background-color: $color-azure;
  }

  @at-root [data-theme="yellow"] & {
    background-color: $color-yellow;
  }

  @at-root [data-theme="ocher"] & {
    background-color: $color-ocher;
  }

  .button__cont {
    position: relative;
    width: 140px;
    height: 140px;
  }

  .button__link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

    border-radius: 60px;

    display: flex;
    align-items: center;
    justify-content: center;

    span {
      display: inline-block;
      line-height: 20px;
    }
  }
}
</style>
